import React, { useState } from "react";

import BlogPostForm from "./components/BlogPostForm";

import { backendPost } from "@accredo/fe-shared/services/dataService.js";
import { Box } from "@mui/material";

import { useSnackbar } from "notistack";
import { useNavigate } from "react-router";

export default function BlogPostCreatePage() {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  const handleCreate = async (payload) => {
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const res = await backendPost("data/blog-posts", {
        toSend: payload,
        label: "Neuer News-Beitrag",
        enqueueSnackbar,
      });

      setSuccess("News-Beitrag erfolgreich erstellt");

      navigate(`/admin/blog/${res.data.id}`);
    } catch (err) {
      err.error(err);
      setError(err?.response?.data?.message || "Fehler beim Erstellen");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 600, margin: "auto" }}>
      <BlogPostForm
        title="Neuer News-Beitrag"
        submitLabel="News-Beitrag erstellen"
        onSubmit={handleCreate}
        loading={loading}
        success={success}
        error={error}
      />
    </Box>
  );
}
